const fontStretch = {
  name: "font-stretch",
  path: "/font-stretch",
  title: "font-stretch",
  description: "Utilities for controlling the font stretch of text.",
  value: {
    "font-stretch": {
      "font-stretch-ultra-condensed": "ultra-condensed",
      "font-stretch-extra-condensed": "extra-condensed",
      "font-stretch-condensed": "condensed",
      "font-stretch-semi-condensed": "semi-condensed",
      "font-stretch-normal": "normal",
      "font-stretch-semi-expanded": "semi-expanded",
      "font-stretch-expanded": "expanded",
      "font-stretch-extra-expanded": "extra-expanded",
      "font-stretch-ultra-expanded": "ultra-expanded",
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="font-stretch-ultra-condensed text-lg">The quick brown fox jumps over the lazy dog. (ultra-condensed)</p>
<p class="font-stretch-extra-condensed text-lg">The quick brown fox jumps over the lazy dog. (extra-condensed)</p>
<p class="font-stretch-condensed text-lg">The quick brown fox jumps over the lazy dog. (condensed)</p>
<p class="font-stretch-semi-condensed text-lg">The quick brown fox jumps over the lazy dog. (semi-condensed)</p>
<p class="font-stretch-normal text-lg">The quick brown fox jumps over the lazy dog. (normal)</p>
<p class="font-stretch-semi-expanded text-lg">The quick brown fox jumps over the lazy dog. (semi-expanded)</p>
<p class="font-stretch-expanded text-lg">The quick brown fox jumps over the lazy dog. (expanded)</p>
<p class="font-stretch-extra-expanded text-lg">The quick brown fox jumps over the lazy dog. (extra-expanded)</p>
<p class="font-stretch-ultra-expanded text-lg">The quick brown fox jumps over the lazy dog. (ultra-expanded)</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-4">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">font-stretch-ultra-condensed</code> through <code class="text-color-gray-800 dark:text-color-white font-semibold">font-stretch-ultra-expanded</code> to control the font stretch:
      </p>
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-4">Note: Some fonts provide additional faces; condensed faces and expanded faces. For these fonts, you can use the font-stretch property to select a normal, condensed, or expanded font face.</p>
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">Note: This property has no effect if the selected font does not offer condensed or expanded faces!</p>
      <div class="space-y-6">
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-ultra-condensed</small>
            <p class="font-stretch-ultra-condensed text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-extra-condensed</small>
            <p class="font-stretch-extra-condensed text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-condensed</small>
            <p class="font-stretch-condensed text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-semi-condensed</small>
            <p class="font-stretch-semi-condensed text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-normal</small>
            <p class="font-stretch-normal text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-semi-expanded</small>
            <p class="font-stretch-semi-expanded text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-expanded</small>
            <p class="font-stretch-expanded text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-extra-expanded</small>
            <p class="font-stretch-extra-expanded text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
            <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">font-stretch-ultra-expanded</small>
            <p class="font-stretch-ultra-expanded text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
}
export default fontStretch;
<div className="sr-only font-stretch-ultra-condensed font-stretch-extra-condensed font-stretch-condensed font-stretch-semi-condensed font-stretch-normal font-stretch-semi-expanded font-stretch-expanded font-stretch-extra-expanded font-stretch-ultra-expanded"></div>